import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './WidgetPageHeader.scss';

const WidgetPageHeader = ({
  children,
  className,
}) => (
  <div className={cx('WidgetPageHeader', className)}>
    {children}
  </div>
);

WidgetPageHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.element
    ),
  ]),
  className: PropTypes.string,
};

WidgetPageHeader.defaultProps = {
  children: null,
  className: undefined,
};

export default WidgetPageHeader;
